import { plural } from "Functions/helpers";

const lang = document.querySelector("html").getAttribute("lang");
let locale;
import(`Locale/${lang}`).then((module) => {
    locale = module.Switch;
});

const getters = {
    allAddresses(state) {
        state.courierAddresses.sort((a, b) => {
            return a.id == state.selectedAddressId ? -1 : 1;
        });

        return state.pickupAddresses.concat(state.courierAddresses);
    },
    selectedDate(state) {
        return state.dates.find((date) => date.id == state.selectedDateId);
    },
    first7Dates(state) {
        return state.dates.length > 7 ? state.dates.slice(0, 7) : state.dates;
    },
    simpleDates(state) {
        return state.dates.map((x) => x.date);
    },
    hasOtherDateSelected(state, getters) {
        return !getters.first7Dates.some((date) => date.id == state.selectedDateId);
    },
    filteredAddresses(state, getters) {
        let shownAddresses = getters.allAddresses;

        if (state.activeAddressesTab) {
            shownAddresses =
                state.activeAddressesTab === "pickup"
                    ? state.pickupAddresses
                    : state.courierAddresses;
        }

        return state.isAllAddressesShown
            ? shownAddresses
            : shownAddresses.slice(0, state.shownAddressesCount);
    },
    otherAddressesText(state, getters) {
        if (state.isAllAddressesShown) {
            return locale.Addresses.hide;
        }

        let shownAddresses = getters.allAddresses;

        if (state.activeAddressesTab) {
            shownAddresses =
                state.activeAddressesTab === "pickup"
                    ? state.pickupAddresses
                    : state.courierAddresses;
        }

        let toReturn = "+";
        toReturn += shownAddresses.length - state.shownAddressesCount;
        toReturn +=
            " " +
            plural(
                locale.Addresses.other1,
                locale.Addresses.other24,
                locale.Addresses.other5,
                shownAddresses.length - state.shownAddressesCount
            );

        return toReturn;
    },
    isAllAddressesLinkShown(state, getters) {
        let shownAddresses = getters.allAddresses;

        if (state.activeAddressesTab) {
            shownAddresses =
                state.activeAddressesTab === "pickup"
                    ? state.pickupAddresses
                    : state.courierAddresses;
        }

        return shownAddresses.length > state.shownAddressesCount;
    },
    isAutocompleteShown(state) {
        return (
            !window.Eshop.options.isLogged &&
            state.courierAddresses.length == 0 &&
            state.activeAddressesTab == "courier"
        );
    },
    selectedAddress(state, getters) {
        if (state.selectedAddressId === null) {
            return '';
        }

        if (state.autocompleteAddressIsUsed) {
            return state.autocompleteValue;
        }

        let shownAddresses = getters.allAddresses;
        let selectedAddress = shownAddresses.find((address) => address.id == state.selectedAddressId);

        return selectedAddress || '';
    },
    showTabs(state) {
        return state.selectedAddressId === null || state.wannaChangeAddress;
    },
    headerTitle(state) {
        if (state.selectedAddressId === null) {
            return locale.Header.title1;
        }

        if (state.wannaChangeAddress) {
            return locale.Header.title2;
        }

        return locale.Header.title3;

    },
    addressesTitle(state) {
        if (state.activeAddressesTab === "pickup") {
            return locale.Addresses.title2;
        }

        return locale.Addresses.title1;
    },
    hasError(state) {
        return state.datesErrorMessage || state.processErrorMessage;
    },
    isReadyForSubmit(state, getters) {
        const withoutErrors = !state.datesErrorMessage && !state.processErrorMessage;
        const dataIsSet = state.selectedAddressId !== null && state.selectedDateId !== null && state.selectedTimeId !== null;
        const withoutDisabledParts = !state.isAddressesDisabled && !state.isDatesDisabled && !state.isTimesDisabled;
        const withoutFetching = !state.isInitialAddressesFetch && !state.isInitialDatesFetch && !state.isInitialTimesFetch;

        if (withoutErrors && dataIsSet && withoutDisabledParts && withoutFetching) {
            if (state.autocompleteAddressIsUsed && !state.wannaChangeAddress) {
                return true;
            }

            if (getters.selectedAddress.isStorePickup && !state.wannaChangeAddress) {
                return true;
            }

            return getters.selectedAddressIsInActiveTab;
        }

        return false;
    },
    datesAndTimesAreVisible(state, getters) {
        if (state.selectedAddressId === null) {
            return false;
        }

        if (state.autocompleteAddressIsUsed && !state.wannaChangeAddress) {
            return true;
        }

        if (getters.selectedAddress.isStorePickup && !state.wannaChangeAddress) {
            return true;
        }

        return getters.selectedAddressIsInActiveTab;
    },

    activeTabFromAddress(state, getters) {
        const defaultTab = "courier";

        if (state.selectedAddressId !== null) {
            if (getters.selectedAddress) {
                return getters.selectedAddress.isStorePickup ? "pickup" : "courier";
            }
        }

        return defaultTab;
    },

    selectedAddressIsInActiveTab(state, getters) {
        if (state.selectedAddressId === null) {
            return false;
        }

        if (getters.isAutocompleteShown) {
            return false;
        }

        if (getters.selectedAddress) {
            const isPickup = getters.selectedAddress.isStorePickup;

            return (
                (isPickup && state.activeAddressesTab === "pickup") ||
                (!isPickup && state.activeAddressesTab === "courier")
            );
        }

        return !state.wannaChangeAddress && state.autocompleteValue !== '';
    },

    showAddAddressLink(state) {
        return window.Eshop.options.isLogged && state.activeAddressesTab === "courier";
    }
};

export default getters;
